export enum SalesforceFormTypes {
  DATE_LABELLING = 'LOOK-SMELL-TASTE',
  PARCELS = 'TOO GOOD TO GO PARCELS',
  PLATFORM = 'Platform',
}

export enum PlatformProducts {
  PLATFORM_AI = 'AI-POWERED DISCOUNTING',
  PLATFORM_EXPIRY = 'EXPIRY DATE MANAGEMENT+',
  PLATFORM_DONATIONS_BUSINESS = 'DONATIONS+ (BUSINESS)',
  PLATFORM_DONATIONS_CHARITY = 'DONATIONS+ (CHARITY)',
}


